import { contactData, featuresData } from '@/mocks/51cgHomeData';

export function ContactSection() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          {contactData.title}
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">{contactData.subtitle}</p>

        <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
            {contactData.description}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-6">
            <div className="flex-1 flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100/80 text-accent-600">
                <i className="ri-mail-line text-lg"></i>
              </span>
              <div>
                <span className="block text-xs text-foreground-400">投稿邮箱</span>
                <span className="text-sm font-semibold text-foreground-800">{contactData.email}</span>
              </div>
            </div>
            <div className="flex-1 flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100/80 text-secondary-600">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <div>
                <span className="block text-xs text-foreground-400">微信联系</span>
                <span className="text-sm font-semibold text-foreground-800">{contactData.wechat}</span>
              </div>
            </div>
          </div>

          <p className="text-xs md:text-sm text-foreground-500 bg-background-50 rounded-lg p-4 border border-background-200/60">
            <i className="ri-information-line mr-1.5"></i>
            {contactData.tips}
          </p>
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  const carouselItems = [
    {
      id: 'car-1',
      title: '51cg莫里秀年度盘点：十大找爹名场面',
      desc: '回顾这一年莫里秀找爹系列中最令人瞠目结舌的十个瞬间',
      tag: '年度专题',
      image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20magazine%20cover%20illustration%20with%20warm%20coral%20tones%2C%20abstract%20news%20media%20collage%20style%2C%20newspaper%20textures%2C%20bold%20typography%20elements%2C%20dynamic%20composition%2C%20warm%20beige%20and%20burgundy%20color%20palette%2C%20sophisticated%20editorial%20design&width=600&height=375&seq=51cg-carousel-1&orientation=landscape',
    },
    {
      id: 'car-2',
      title: '某知名女团成员被曝恋情，男方身份引全网猜测',
      desc: '51cg爆料独家追踪，揭开偶像背后不为人知的感情世界',
      tag: '独家爆料',
      image: 'https://readdy.ai/api/search-image?query=Vibrant%20pop%20culture%20illustration%20with%20silhouettes%20of%20idol%20performers%2C%20heart%20motifs%2C%20question%20marks%2C%20and%20news%20headlines%20floating%20in%20a%20dynamic%20composition%2C%20warm%20peach%20and%20rose%20color%20scheme%2C%20tabloid%20magazine%20aesthetic%2C%20mysterious%20atmosphere&width=600&height=375&seq=51cg-carousel-2&orientation=landscape',
    },
    {
      id: 'car-3',
      title: '51cg.fun黑料吃瓜：娱乐圈"潜规则"实录',
      desc: '多位圈内人士匿名投稿，还原行业真实生态',
      tag: '深度报道',
      image: 'https://readdy.ai/api/search-image?query=Dark%20and%20dramatic%20editorial%20illustration%20showing%20hidden%20doors%20and%20shadows%20behind%20a%20glamorous%20stage%20curtain%2C%20warm%20burgundy%20and%20gold%20accents%2C%20investigative%20journalism%20mood%2C%20film%20noir%20inspired%20composition%2C%20mysterious%20and%20compelling%20visual&width=600&height=375&seq=51cg-carousel-3&orientation=landscape',
    },
    {
      id: 'car-4',
      title: '网红翻车事件全记录：从顶流到塌房',
      desc: '51cg情感八卦盘点近期最轰动的网红人设崩塌事件',
      tag: '热门合集',
      image: 'https://readdy.ai/api/search-image?query=Collapsing%20social%20media%20icons%20and%20falling%20crowns%20illustration%2C%20dramatic%20crumbling%20effect%2C%20warm%20coral%20and%20dusty%20rose%20tones%2C%20viral%20content%20themed%2C%20dynamic%20digital%20art%20style%2C%20trending%20topic%20aesthetic&width=600&height=375&seq=51cg-carousel-4&orientation=landscape',
    },
    {
      id: 'car-5',
      title: '某综艺节目后台冲突视频流出，导演组紧急回应',
      desc: '51cg在线观看独家获取的综艺幕后真实画面',
      tag: '独家视频',
      image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20show%20set%20illustration%20with%20cameras%2C%20dramatic%20lighting%2C%20silhouettes%20in%20conflict%2C%20warm%20amber%20and%20deep%20red%20color%20palette%2C%20reality%20TV%20drama%20mood%2C%20cinematic%20composition%2C%20urgent%20breaking%20news%20feel&width=600&height=375&seq=51cg-carousel-5&orientation=landscape',
    },
    {
      id: 'car-6',
      title: '51cg黑料合集：2025上半年娱乐圈大事记',
      desc: '从恋情曝光到税务风波，半年来最值得记住的51cg爆料事件',
      tag: '半年回顾',
      image: 'https://readdy.ai/api/search-image?query=Timeline%20collage%20illustration%20of%20entertainment%20news%20events%2C%20newspaper%20clippings%2C%20magnifying%20glass%2C%20bold%20headlines%2C%20warm%20terracotta%20and%20cream%20color%20scheme%2C%20scrapbook%20aesthetic%2C%20retro%20editorial%20design%2C%20half-year%20review%20theme&width=600&height=375&seq=51cg-carousel-6&orientation=landscape',
    },
  ];

  return (
    <section id="carousel" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          重磅专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">51cg深度报道与独家策划</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden cursor-pointer hover:border-accent-200 transition-all duration-300"
            >
              <div className="relative w-full aspect-[16/10] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          为什么选51cg
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">三大优势让你爱上51cg吃瓜网</p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/70"
            >
              <span className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100/80 text-accent-600 text-2xl mb-4">
                <i className={item.icon}></i>
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}